var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8File(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.2,
    height: 24,
    viewBox: "0 0 19.2 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-file_1_",
    "data-name": "icons8-file (1)",
    className: "cls-1",
    d: "M10.7,4A2.714,2.714,0,0,0,8,6.7V25.3A2.714,2.714,0,0,0,10.7,28H24.5a2.714,2.714,0,0,0,2.7-2.7V12.7a.9.9,0,0,0-.264-.636l-.009-.009L19.136,4.264A.9.9,0,0,0,18.5,4Zm0,1.8h6.9v5.1a2.714,2.714,0,0,0,2.7,2.7h5.1V25.3a.886.886,0,0,1-.9.9H10.7a.886.886,0,0,1-.9-.9V6.7A.886.886,0,0,1,10.7,5.8Zm8.7,1.273L24.127,11.8H20.3a.886.886,0,0,1-.9-.9Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8File);
export default __webpack_public_path__ + "static/media/icons8-file.936ae14c2ff866e853715f4f7787ddc2.svg";
export { ForwardRef as ReactComponent };